package com.tregz.robbins

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlinx.browser.window

@JsModule("firebase/app")
@JsNonModule
external object FirebaseApp {
    val initializeApp: (config: dynamic) -> dynamic
}

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val config = js("{}")
    config.apiKey = js("process.env['FIREBASE_API_KEY']") as? String ?: ""
    config.authDomain = "robbins-bb140.firebaseapp.com"
    config.projectId = "robbins-bb140"
    config.storageBucket = "robbins-bb140.firebasestorage.app"
    config.messagingSenderId = "435963043053"
    config.appId = "1:435963043053:web:038affc15ce7ec861500e4"
    config.measurementId = "G-011DB34L8B"
    FirebaseApp.initializeApp(config)

    val path = window.location.pathname.lowercase()
    val initialScreen = when {
        path.contains("jerome") -> Screen.Jerome
        path.contains("terrence") -> Screen.Terrence
        else -> Screen.Main
    }

    ComposeViewport {
        App(initialScreen)
    }
}
